import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/Card'
import { Badge } from '../ui/Badge'
import { TrendingUp, TrendingDown, Users, Building2, Truck, Activity } from 'lucide-react'

const mockOverviewData = [
  {
    title: "Total Companies",
    value: "24",
    change: "+2 this month",
    trend: "up",
    icon: Building2,
    description: "Active hospitals & fleet operators"
  },
  {
    title: "Active Users",
    value: "1,842",
    change: "+12% from last month",
    trend: "up", 
    icon: Users,
    description: "Dispatchers, drivers, and staff"
  },
  {
    title: "Fleet Vehicles",
    value: "156",
    change: "+8 new vehicles",
    trend: "up",
    icon: Truck,
    description: "Total ambulances in network"
  },
  {
    title: "Today's Requests",
    value: "89",
    change: "-5% vs yesterday",
    trend: "down",
    icon: Activity,
    description: "Emergency transport requests"
  }
]

const OverviewCards = () => {
  return (
    <div className="grid gap-3 sm:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      {mockOverviewData.map((item, index) => {
        const Icon = item.icon
        const TrendIcon = item.trend === 'up' ? TrendingUp : TrendingDown
        
        return (
          <Card key={index} className="hover:shadow-md transition-shadow cursor-pointer">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2 px-3 pt-3 sm:px-4 sm:pt-4 md:px-6 md:pt-6">
              <CardTitle className="text-xs sm:text-sm font-medium leading-tight min-w-0 flex-1">
                {item.title}
              </CardTitle>
              <Icon className="h-3 w-3 sm:h-4 sm:w-4 text-muted-foreground flex-shrink-0 ml-2" />
            </CardHeader>
            <CardContent className="px-3 pb-3 sm:px-4 sm:pb-4 md:px-6 md:pb-6">
              <div className="text-lg sm:text-xl md:text-2xl font-bold leading-none">
                {item.value}
              </div>
              <div className="flex items-center gap-1 mt-2">
                <TrendIcon className={`h-3 w-3 flex-shrink-0 ${item.trend === 'up' ? 'text-green-500' : 'text-red-500'}`} />
                <p className="text-xs text-muted-foreground leading-tight min-w-0">
                  {item.change}
                </p>
              </div>
              <p className="text-xs text-muted-foreground mt-2 leading-relaxed break-words">
                {item.description}
              </p>
            </CardContent>
          </Card>
        )
      })}
    </div>
  )
}

export default OverviewCards